import { InventoryPayloadItem } from '../config/types';

export function isEstimatedData(params: InventoryPayloadItem | null | undefined) {
  return params?.type === 'FLOOR';
}

export default isEstimatedData;
